var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseNotificationOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99892 7.20997L10.2319 11.4436L11.4416 10.2337L7.20857 6.00014L11.4436 1.76452L10.2339 0.554688L5.99892 4.79032L1.76434 0.555122L0.554688 1.76495L4.78926 6.00014L0.556711 10.2333L1.76636 11.4431L5.99892 7.20997Z",
    fill: "var(--secondary-5)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNotificationOutlined);
export default __webpack_public_path__ + "static/media/closeNotificationOutlined.b86576f1c6f4c615808002429b9d847b.svg";
export { ForwardRef as ReactComponent };